import { seoFavicon } from './SeoStore';

export const updateSeoFavicon = (value) => seoFavicon.update(oldValue => value);
